import React from 'react';
import cx from 'classnames';
import styles from './zohoConfigurationView.module.scss';
import { toast } from 'react-toastify';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { 
  Row, Col, FormGroup, InputGroup, FormControl, Form
} from 'react-bootstrap';
import SwitchButton from 'src/components/switchButton';
import SendButton from 'src/legacy/components/SendButton';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import AccessDeniedIcon from 'src/legacy/images/access_denied.svg';
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';
import Toast from 'src/components/toast';

class ZohoConfigurationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
      integrationCreatedBy: _.get(this.props.integration, "createdBy") || '',
      email: integration && integration.configuration.email || '',
      syncReadAssetEvent: integration && integration.configuration.syncReadAssetEvent || false,
      syncReadConversationEvent: integration && integration.configuration.syncReadConversationEvent || false,
      syncReshareConversationEvent: integration && integration.configuration.syncReshareConversationEvent || false,
      syncLeadCreatedEvent: integration && integration.configuration.syncLeadCreatedEvent || false,
      syncAssetDownloadEvent: integration && integration.configuration.syncAssetDownloadEvent || false,
      errors: {},
    }

    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedZoho = localizedStrings.components.integrations.zoho;
  }

  componentDidMount() {   
  }

  _toggleSwitchChange(field){
   

    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked(){
  
    let request = {
      syncLeadCreatedEvent: this.state.syncLeadCreatedEvent,
      syncReadAssetEvent: this.state.syncReadAssetEvent,
      syncReadConversationEvent: this.state.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.syncReshareConversationEvent,
      syncAssetDownloadEvent: this.state.syncAssetDownloadEvent
    }

    this.props.updateConfiguration(request).then(() => {
        toast(
          <Toast.Sucess
            message = {this.localizedIntegrations.toast.zoho}            
          /> , {
            autoClose: 3000,
        })
    });
  }

  _handleResetClicked(){
    this.setState({
      syncLeadCreatedEvent: this.props.integration.configuration.syncLeadCreatedEvent,
      syncReadAssetEvent: this.props.integration.configuration.syncReadAssetEvent,
      syncReadConversationEvent: this.props.integration.configuration.syncReadConversationEvent,
      syncReshareConversationEvent: this.props.integration.configuration.syncReshareConversationEvent,
      syncAssetDownloadEvent: this.props.integration.configuration.syncAssetDownloadEvent,
    });
  }

  render(){
    return (
      <div className={styles.content}>
        {this.props.integration && this.props.integration.state.code === "auth_error" &&
          <span className={styles.authMessage}>
            {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
          </span>
        }

        {this.props.loading && this._renderLoading()}

        {!this.props.loading && this._renderAdminConfiguration()}

      </div>
    )
  }

  _renderAdminConfiguration() {
    return (
        <Row className={styles.row}>
          <Col md={8} mdOffset={1}>
            <div className={styles.form}>
              <p className={styles.errorMessage}>{this.state.errors && this.state.errors.apikey}</p>
              <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className = {styles.disableEmail}>
                <div className={styles.start}>
                  <span>{ this.localizedCommons.email }</span>
                </div>
                <FormControl
                  type='text'
                  placeholder=""
                  value={this.state.email}
                  disabled
                  
                   />
              </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedZoho.active }</Form.Text>

              <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <h5>{ this.localizedIntegrations.sync_events }</h5>
                </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedZoho.configuration.sync.sub_text }</Form.Text>

              <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.create_lead }</label>
                  <SwitchButton 
                    id="syncLeadCreatedEvent"
                    checked={this.state.syncLeadCreatedEvent}
                    handleCheck={() => this._toggleSwitchChange("syncLeadCreatedEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_asset }</label>
                  <SwitchButton 
                    id="syncReadAssetEvent"
                    checked={this.state.syncReadAssetEvent}
                    handleCheck={() => this._toggleSwitchChange("syncReadAssetEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_collection }</label>
                  <SwitchButton 
                    id="syncReadConversationEvent"
                    checked={this.state.syncReadConversationEvent}
                    handleCheck={() => this._toggleSwitchChange("syncReadConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                  <SwitchButton 
                    id="syncReshareConversationEvent"
                    checked={this.state.syncReshareConversationEvent}
                    handleCheck={() => this._toggleSwitchChange("syncReshareConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.download_asset }</label>
                  <SwitchButton 
                    id="syncAssetDownloadEvent"
                    checked={this.state.syncAssetDownloadEvent}
                    handleCheck={() => this._toggleSwitchChange("syncAssetDownloadEvent")} />
                </div>
              </FormGroup>

              {this.props.user.admin &&
                <div className={styles.buttonTray}>
                  <SendButton
                    className={cx(styles.save)}
                    icon="fa-chevron-right"
                    title={this.props.updating ? `${this.localizedCommons.actions.saving_changes}...` : this.localizedCommons.actions.save }
                    primary
                    disabled={this.props.updating}
                    onClick={this._handleSaveChangesClicked}
                  >
                  </SendButton>
                  <SendButton
                    title={this.localizedCommons.actions.reset}
                    disabled={this.props.updating}
                    className={cx(styles.cancel)}
                    onClick={this._handleResetClicked}
                  >
                  </SendButton>
                </div>
              }
            </div>
          </Col>
        </Row>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedZoho.empty_message.title}
        message={this.localizedZoho.empty_message.sub_text}
        image={AccessDeniedIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage 
        className={styles.loadingMessage}
        message={this.localizedZoho.loading}
        visible={true} />
    )
  }
}

export default ZohoConfigurationView;